<h1 class="page-title mb-5">الإتفاقيات التجارية</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <P class="textPrimary">الوصول إلى الأسواق</P>
        <p>
          يتيح الموقع الاستراتيجي لمصر فرصة متميزة للوصول إلى الأسواق بالإضافة
          إلى العديد من الحوافز التي توفرها اتفاقيات التجارة وتستفيد منها
          الأنشطة العاملة في مصر.
        </p>
        <p>
          توفر اتفاقيات التجارة الحرة المتعددة الوصول إلى 1.5 مليار مستهلك منهم
          100 مليون مستهلك في مصر، بالإضافة إلى أنها تربط المستثمرين بالأسواق
          القائمة والناشئة بنسبة 8٪ من التجارة العالمية التي تمر عبر قناة
          السويس؛ كما أن وقت وتكلفة الشحن أقل في مصر ويستغرق سبعة (7) أيام أقل
          إلى الولايات المتحدة من الصين وتكلفة 50٪ أقل مقارنة بالإمارات المتحدة.
        </p>
        <p>اتفاقيات التجارة</p>
        <ol>
          <li>اتفاقية التجارة الحرة العربية الكبرى (جافتا)</li>
          <li>السوق المشتركة لشرق وجنوب أفريقيا (كوميسا)</li>
          <li>اتفاقية أغادير للتجارة الحرة</li>
          <li>اتفاقية الشراكة بين مصر والاتحاد الأوروبي</li>
          <li>
            اتفاقية التجارة الحرة بين مصر ورابطة التجارة الحرة الأوروبية (إفتا)
          </li>
          <li>المناطق الصناعية المؤهلة (كويز)</li>
          <li>اتفاقية التجارة الحرة بين مصر وتركيا</li>
          <li>
            اتفاقية التجارة الحرة بين مصر والسوق المشتركة الجنوبية (ميركوسور)
          </li>
        </ol>
        <p class="textPrimary">اتفاقية التجارة الحرة العربية الكبرى (جافتا)</p>
        <p>
          وقع سبعة عشر (17) عضوًا في جامعة الدول العربية عام 1981 اتفاقية
          التجارة الحرة العربية واتفقوا على شروطها عام 1997 بهدف تيسير وتطوير
          التجارة بين الدول العربية، واتفق أعضاء الاتفاقية على القضاء على
          الحواجز غير الجمركية من ضمنها الحواجز الإدارية والنقدية والمالية
          والفنية وتخفيض الرسوم الجمركية سنويا لمدة عشر (10) سنوات (تخفيض سنوي
          بنسبة 10٪ من عام 1998 إلى عام 2003 و20٪ في عامي 2004 و2005) حتى الوصول
          إلى منطقة تجارة حرة عام 2007، وعلى الرغم من ذلك، قررت القمة العربية
          عام 2002 الوصول إلى تخفيض بنسبة 100٪ على الرسوم الجمركية عام 2005 بدلا
          من عام 2007 ومنح الدول الأعضاء الأقل نموًا معاملة تفضيلية.
        </p>
        <p class="textPrimary">السوق المشتركة لشرق وجنوب أفريقيا (كوميسا)</p>

        <p>
          بدأت اتفاقية السوق المشتركة لشرق وجنوب أفريقيا (الكوميسا) كمنطقة تجارة
          تفضيلية تهدف للوصول لإقامة منطقة تجارة حرة بين الدول الأعضاء لتصبح
          اتحادا جمركيا ثم سوقاً مشتركة، وأصبحت مصر عضوًا في الكوميسا عام 1998
          بجانب 19 من الدول الأعضاء النشطة الأخرى، وتعفي مصر كعضو في الكوميسا
          البضائع والمنتجات التي تحمل شهادات المنشأ من الكوميسا تماما من الرسوم
          الجمركية وأي رسوم وضرائب أخري ذات الأثر المماثل، وبالإشارة إلى قواعد
          المنشأ الخاصة بالاتفاقية، تطبق الإعفاءات الجمركية على جميع واردات
          السلع التي يكون منشأها الدول الأعضاء بقيمة مضافة تصل على 45٪، بدأت
          الكوميسا اتحادها الجمركي في يونيو 2009 بهدف تخفيض وتوحيد التعريفة
          الجمركية الخارجية خطيًا على مدار عشر (10) سنوات تبدأ في عام 2009
          وتنتهي في عام 2018، ومن المقرر إقامة اتحادًا نقديا بحلول 2025.
        </p>
        <p class="textPrimary">اتفاقية أغادير للتجارة الحرة</p>
        <p>
          وقعت مصر اتفاقية أغادير عام 2004 من أجل إقامة منطقة تجارة حرة بين
          الأردن والمغرب وتونس، ودخلت الاتفاقية حيز التنفيذ عام 2006.
        </p>
        <p class="font-weight-bold">مزايا الاتفاقية</p>
        <ol>
          <li>
            تطبيق قواعد تراكم المنشأ سيدعم ويسهل التعاون الاقتصادي والتجاري بين
            الأطراف.
          </li>
          <li>
            السعي نحو إقامة وتطوير منطقة التجارة الحرة العربية الكبرى، كمساندة
            للجهود المبذولة لإقامة سوق عربية مشتركة.
          </li>
          <li>
            وكان إعلان أغادير منافذ أكثر لتوسيع أسواق الاتحاد الأوروبي وذلك بعد
            انضمام عشر (10) دول أعضاء جديدة.
          </li>
          <li>
            سيعزز إعلان أغادير تبادلات التجارة بين مصر والدول العربية الموقعة
            عليه حيث أن حجم التجارة العربية بين الدول العربية بعضها ببعض لا
            يتجاوز 10% من حجم تجارتها الحالية.
          </li>
          <li>
            تتناول هذه الاتفاقية العديد من القضايا الهامة مثل الأنظمة الجمركية
            وقواعد المنشأ والمشتريات الحكومية والمعاملات المالية وتدابير الحماية
            والصناعات الجديدة والدعم والإغراق والملكية الفكرية والمعايير
            والمواصفات وإنشاء آلية لتسوية المنازعات، وقواعد المنشأ من أهم المواد
            المنصوص عليها في اتفاقية أغادير حيث من المتوقع لها زيادة إمكانية
            الوصول إلى الأسواق الأوروبية بالنسبة لمنتجات الدول الأطراف، مما
            سيشجع بالتالي الاستثمارات ويزيد التعاون الإقليمي بين الدول.
          </li>
        </ol>
        <p>
          تعفى جميع المنتجات الصناعية والزراعية من كامل التعريفة الجمركية
          والتدابير غير الجمركية بمجرد دخول الاتفاقية حيز التنفيذ.
        </p>
        <p class="textPrimary">اتفاقية الشراكة بين مصر والاتحاد الأوروبي</p>
        <p>
          اتفاقية الشراكة بين مصر والاتحاد الأوروبي سارية المفعول منذ عام 2004،
          فهي تخلق منطقة تجارة حرة بين الاتحاد الأوروبي ومصر من خلال إزالة
          التعريفات على المنتجات الصناعية وتسهيل تجارة المنتجات الزراعية، ودخل
          اتفاق آخر بشأن الزراعة ومعالجة المنتجات الزراعية والسمكية حيز التنفيذ
          في عام 2010، ويركز اتفاق التجارة الحرة على زيادة التجارة بين المنطقتين
          عن طريق تخفيض الرسوم الجمركية تدريجيا سنويا على التجارة حتى يتم
          إلغائها نهائيا على منتجات معينة، ومنذ عام 2004، ازدادت التجارة
          الثنائية بين الاتحاد الأوروبي ومصر بأكثر من الضعف حيث كانت 11.8 مليار
          يورو في عام 2004 ووصلت إلى 27.9 مليار يورو في عام 2017، وكانت الواردات
          الرئيسية للاتحاد الأوروبي من مصر عام 2017 عبارة عن منتجات الوقود
          والتعدين (3.2 مليار يورو) والكيماويات (1.3 مليار يورو) والمنسوجات
          والملابس (8.6 مليار يورو)، وكانت صادرات الاتحاد الأوروبي الرئيسية إلى
          مصر عبارة عن الآلات ومعدات النقل (6.9 مليار يورو)، والكيماويات (3.1
          مليار يورو) والوقود ومنتجات التعدين (2.6 مليار يورو) والمنتجات
          الزراعية (1.3 مليار يورو).
        </p>
        <p class="textPrimary">
          اتفاقية التجارة الحرة بين مصر ورابطة التجارة الحرة الأوروبية (إفتا)
        </p>
        <p>
          وقعت الدول الأعضاء في رابطة التجارة الحرة الأوروبية (إفتا)، ومنها
          أيسلندا وليختنشتاين والنرويج وسويسرا، على اتفاقية تجارة حرة مع مصر
          ودخلت حيز التنفيذ في عام 2007 من أجل دعم وزيادة التجارة الثنائية بين
          مصر ودول اتفاقية (الإفتا)، وكذلك تعزيز التكامل الاقتصادي في منطقة
          الأورومتوسطي من خلال تحرير التجارة في المنتجات الصناعية والزراعية
          المصنعة، وبناء عليه، يتم تحرير الصادرات المصرية من المنتجات الصناعية،
          وسيتم تخفيض التعريفة الجمركية المصرية تدريجيا على الواردات الصناعية من
          دول الإفتا حتى يناير 2020 عندما يتم إلغاء الرسوم الجمركية على جميع
          المنتجات الصناعية تمامًا.
        </p>
        <p class="font-weight-bold">المزايا التجارية للاتفاقية:</p>
        <ol>
          <li>
            إلغاء جميع الرسوم الجمركية والضرائب على الصادرات المصرية الصناعية
            إلى دول الإفتا.
          </li>
          <li>
            فتح الأسواق أمام إقامة صناعات تصديرية في مصر لتصدير منتجاتها إلى دول
            الإفتا.
          </li>
          <li>
            تقديم مزايا وإعفاءات جمركية للصادرات المصرية إلى دول الإفتا من السلع
            الزراعية وخاصة المنتجات ذات الأهمية لمصر مثل البطاطس والبرتقال
            والطماطم والزهور.
          </li>
          <li>
            تطبيق مصر لقواعد المنشأ الأورومتوسطية التي تم تطبيقها على اتفاقية
            الشراكة المصرية الأوروبية.
          </li>
          <li>
            إلغاء جميع التعريفات الجمركية على الأسماك والمنتجات البحرية الأخرى
            خلال أربع عشرة (14) سنة من تاريخ الاتفاقية.
          </li>
          <li>
            حصول مصر على مساعدات مالية وتقنية من دول الإفتا لتنمية القطاع
            الزراعي وقطاع مصائد الأسماك والمساهمة في العديد من المشروعات التي
            تهدف إلى نقل خبراتها في مجالات المنسوجات والملابس والمنتجات
            الدوائية.
          </li>
          <li>
            قيام الإفتا بإعداد دراسة جدوى في مجال صيد الأسماك حول كيفية
            الاستفادة القصوى من بحيرة ناصر.
          </li>
          <li>
            اعتماد الطرفان لسياسة التحرير التدريجي وسياسة الأسواق المفتوحة
            للتجارة في الخدمات وذلك في إطار البنود الأساسية لهذا النوع من
            اتفاقيات التجارة.
          </li>
          <li>
            التزام دول الإفتا بتعزيز التعاون الاقتصادي مع مصر وتقديمها للمساعدات
            الفنية لتسهيل تطبيق الاتفاقية، ويشمل هذا التعاون العمل على تحسين
            القدرات التنافسية ودعم استمرارية الإنجازات في مجال التنمية
            الاقتصادية والاجتماعية.
          </li>
          <li>
            تركيز التعاون الاقتصادي على القطاعات التي تواجه التحديات وعلى النمو
            وكذلك على توفير فرص العمل في مصر بالإضافة إلى توقيع مذكرات التفاهم
            الثنائية حول مشروعات التعاون بين مصر وكل من آيسلندا والنرويج
            وسويسرا.
          </li>
          <li>إنشاء لجنة مشتركة للإشراف على تنفيذ الاتفاقية وعملية التحكيم.</li>
        </ol>

        <p class="textPrimary">المناطق الصناعية المؤهلة (الكويز)</p>
        <p>
          المناطق الصناعية المؤهلة (الكويز) هي مناطق جغرافية محددة، داخل جمهورية
          مصر العربية، تتمتع بالإعفاء من الرسوم الجمركية عند دخول السلع إلى
          الولايات المتحدة الأمريكية، ويُسمَح للشركات المنشأة داخل هذه المناطق
          الدخول إلى الأسواق الأمريكية بدون رسوم جمركية، شريطة استيفائها لقواعد
          المنشأ المتفق عليها والمحددة مسبقًا، وتتنوع مزايا (الكويز) في مصر؛
          وتعتبر ميزة سهولة الوصول إلى الأسواق الأمريكية-بدون حصص محددة-هي
          الأكثر أهمية، فضلًا عن إلغاء الحواجز الجمركية وغير الجمركية، ومن
          المزايا الأخرى لهذه الاتفاقية انخفاض التكلفة وتوفير فرص عمل كثيرة،
          وبفضل المزايا الإضافية التي توفرها الاتفاقيات التجارية المبرمة مع
          الأسواق الأخرى، تعتبر مصر من أنسب الدول التي تقدم مزايا اقتصادية لا
          تحصى للصناعات الموجودة داخل هذه المناطق، وما زال الأثر الاقتصادي
          الإيجابي لاتفاقية الكويز حتى الآن هو السعي المستمر لكل من المستثمرين
          الأجانب والشركات المصرية على حد سواء من أجل التواجد داخل هذه المناطق
          وتأهيل استثماراتهم لزيادة قدرتها على المنافسة وحجم أرباحها، وتتواجد
          المناطق الصناعية التي تعمل بنظام (الكويز) في الإسكندرية وقناة السويس
          والقاهرة الكبرى والدلتا الوسطى كما تم إضافة مناطق جديدة في المنيا وبني
          سويف.
        </p>
        <p class="textPrimary">اتفاقية التجارة الحرة بين مصر وتركيا</p>
        <p>
          وقعت مصر اتفاقية ثنائية للتجارة الحرة مع تركيا في عام 2005، ودخلت هذه
          الاتفاقية حيز التنفيذ في عام 2007 لإنشاء منطقة تجارة حرة بين الدولتين
          على مدى فترة لا تزيد عن اثني عشرة (12) سنة من تاريخ التصديق.
        </p>
        <p>المزايا التجارية للاتفاقية:</p>
        <ol>
          <li>
            إزالة القيود المفروضة على تجارة السلع بما في ذلك المنتجات الزراعية.
          </li>
          <li>خلق بيئة مناسبة لجذب المزيد من الاستثمارات.</li>
          <li>توفير منافسة تجارية عادلة بين الدولتين.</li>
          <li>
            تسهيل الوصول إلى أسواق الاتحاد الأوروبي، كما أن اتفاقيات التجارة
            الحرة بين مصر وأفريقيا مثل اتفاقية الكوميسا تُسهّل الوصول إلى
            المستثمرين الأتراك.
          </li>
        </ol>

        <p>
          ومن ثم، تُعفى الصادرات الصناعية المصرية لتركيا على الفور من الرسوم
          الجمركية ومن الرسوم والضرائب الأخرى ذات الأثر المماثل بمجرد دخول هذه
          الاتفاقية حيز التنفيذ، ومع ذلك، يتم تطبيق معدلات الخصم على قائمة معينة
          من المنتجات والتي تختلف خلال سنوات التشغيل حتى تصل إلى الإعفاء الكامل،
          لا تقدم اتفاقية التجارة الحرة للصادرات الصناعية المصرية حق الوصول
          الكامل والفوري للسوق التركية الكبيرة فحسب، بل تُسهِّل الوصول إلى سوق
          الاتحاد الأوروبي، ويواجه المُصدِّرون المصريون تحديات شديدة في الوصول
          إلى السوق الأوروبي حتى مع اتفاقية الشراكة المحررة بين مصر والاتحاد
          الأوروبي، ومن المتوقع أن تساعد اتفاقية التجارة الحرة بين مصر وتركيا
          المُصدِّرين على التعامل مع اللوائح والمعايير الصارمة للاتحاد الأوروبي
          من خلال دمج الصناعات التركية والمصرية وتمكين المُصدِّرين المصريين من
          الاستفادة من تجربة تركيا في الاتحاد الأوروبي، وعلى نفس القدر من
          الأهمية، من المتوقع أن تزيد اتفاقية التجارة الحرة من الثقة في الاقتصاد
          المصري وأن تجعلها مركزَا لدول أفريقية وأوروبية وعربية أخرى.
        </p>

        <p class="textPrimary">
          اتفاقية التجارة الحرة بين مصر والسوق المشتركة الجنوبية (ميركوسور)
        </p>
        <p>
          في عام 2010، وقعت مصر اتفاقية تجارة حرة تفضيلية مع السوق المشتركة
          الجنوبية (ميركوسور)، والتي تتيح امتيازات تفضيلية للصادرات المصرية
          لدخول أسواق أمريكا اللاتينية وخفض تكلفة الواردات المصرية من دول أمريكا
          اللاتينية مثل السكر واللحوم وزيت الصويا.
        </p>
        <p>
          تهدف اتفاقية التجارة الحرة إلى خفض الرسوم الجمركية بأكثر من 90٪ بين
          مصر ودول الميركوسور وإلغاء الرسوم الجمركية على السلع الزراعية، إلى
          جانب إيجاد حلول لقضايا قواعد المنشأ والضمانات التفضيلية وتعزيز التعاون
          في مجالات الاستثمار والخدمات وغيرها.
        </p>
      </div>
      <div class="col-md-3">
        <app-fixed-sectors></app-fixed-sectors>
      </div>
    </div>
  </div>
</div>